module.exports = __webpack_public_path__ + "img/train-02.805bacb8.png";